// extracted by mini-css-extract-plugin
export default {"test":"test-connection-test-W4JO__"};